import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 16px'
    },
  },
  descricao: {
    color: theme.shared.template.MeuINSSDescricao.descricao.color,
    fontSize: "1.2em !important",
    [theme.breakpoints.down('xs')]: {
      fontSize: '1em !important',
    },
    textAlign: 'left',
    '& a': {
      fontSize: 'inherit'
    }
  }
}));

/**
 * MeuInssDescricao
 * 
 * @param {Object} props
 * @param {string} props.descricao - Texto que será exibido - suporta conteúdo HTML.
 * @param {Object} [props.style] - Estilo inline opcional para ser aplicado ao container.
 * @returns {JSX.Element}
 */
export default function MeuInssDescricao(props) {
  const classes = useStyles();
  return (
    <div className={classes.root} style={props.style}>
      <p className={classes.descricao}>
        <span dangerouslySetInnerHTML={{ __html: props.descricao }} />
      </p>
    </div>
  );
}
